import { FlowItemConfigT } from '../template-types';

function humanizeKeyLabel(rawKey?: string | null) {
  const normalized = String(rawKey || '')
    .replace(/^(q|qs|st|sx)-/i, '')
    .replace(/-+/g, ' ')
    .trim();
  if (!normalized) return '';
  return normalized
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function consolidateFlowItem({ item }: { item: FlowItemConfigT }) {
  const { type, label, reportConfig } = item;

  switch (type) {
    case 'rep-report-template': {
      return JSON.stringify(reportConfig);
    }
    case 'rep-label': {
      const normalized = String(label || '').trim();
      if (/^(q|qs|st|sx)-/i.test(normalized)) {
        return humanizeKeyLabel(normalized) || normalized;
      }
      return label;
    }
    default: {
      return '';
    }
  }
}
